"use strict";
angular.module('broadcastModule', [
	'broadcastRouterModule',
	'broadcastLeftModule',
	'broadcastToBeCompiledModule',
	'broadcastPendingModule',
	'broadcastSignedModule',
	'broadcastServiceModule',
	'broadcastPreviewRouterModule'
	])